// index = listing type code - 1 (sale, rent, short term)
export const LISTING_ROUTES = ['/prodaja', '/izdavanje', '/stan-na-dan'];
// the code of the "Novogradnja" building type
export const NEW_BUILD_OPTION = 'new_build';

export const PRICE_PRESETS = [
    [50000, 100000, 150000, 250000, 500000],
    [300, 500, 800, 1200, 2000],
    [30, 50, 80, 120, 200],
];
export const PRICE_UNITS = ['€', 'price_unit_month', 'price_unit_night'];
// ids from config.num_rooms_options (1.0, 2.0, 3.0, 4.0, 5.0)
export const MIN_ROOM_IDS = [2, 4, 6, 8, 10];

export const formatNumber = (n) => String(Math.round(Number(n) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');

// ignore case and diacritics so "nis" matches "Niš"
export const normalize = (s) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
